import TPL = require("templates");
import {Config} from "../config";
import {ConfirmController} from "../modals/confirm";

export class ChangePasswordController {

  parent;
  session;

  modal;
  currentModal;
  location;

  password;
  errorchangepwd;
  resetPasswordToken;

  constructor(parent, session, modal, location) {
    this.parent = parent;
    this.currentModal = parent.currentModal;
    this.modal = modal;
    this.location = location;
    this.errorchangepwd = "";

    this.session = session;
    this.resetPasswordToken = this.parent.resetPasswordToken;
  }

  submit(form) {
    if (form.$valid) {

      if (this.resetPasswordToken) {
        this.session.changePasswordByToken({password: this.password, resetPasswordToken: this.resetPasswordToken}).then(()=> {

          if (this.currentModal) {
            this.currentModal.dismiss();
          }

          this.location.search('changePassword', null);
          this.location.replace();

          ConfirmController.openPasswordChangeDoneModal(this.modal);

        }).catch((data)=> {
          if (data.data.errors[Config.tokenError]){
            this.errorchangepwd="FORGOT.TOKEN_ERROR";
          }
          if (data.data.errors[Config.minCharError]){
            if(data.data.errors[Config.minCharError]=="is too short (minimum is 8 characters)"){
              this.errorchangepwd="FORGOT.MIN_CHAR_PASSWORD";
            }
          }
        });
      } else {
        this.session.changePassword({password: this.password, password_confirmation: this.password}).then(()=> {

          if (this.currentModal) {
            this.currentModal.dismiss();
          }

          this.location.search('changePassword', null);
          this.location.replace();

          ConfirmController.openPasswordChangeDoneModal(this.modal);

        }).catch((data)=> {
          if (data.data.errors[Config.tokenError]){
            this.errorchangepwd="FORGOT.TOKEN_ERROR";
          }
          if (data.data.errors[Config.minCharError]){
            //alert(data.data.errors[Config.minCharError]);
            if(data.data.errors[Config.minCharError]=="is too short (minimum is 8 characters)"){
              this.errorchangepwd="FORGOT.MIN_CHAR_PASSWORD";
            }
          }
        });
      }

    }
  }

  resetError() {
    this.errorchangepwd=false;
  }

  static openChangePasswordModal(modal, parent, session, location) {
    return ChangePasswordController.openChangePasswordModalInternal(modal, parent, session, location, true);
  }

  static openUndismissableChangePasswordModal(modal, parent, session, location) {
    return ChangePasswordController.openChangePasswordModalInternal(modal, parent, session, location, false);
  }

  private static openChangePasswordModalInternal(modal, parent, session, location, undismissable) {
    var backdrop = undismissable ? 'true' : 'static';

    return modal.open({
          controller: () => new ChangePasswordController(parent, session, modal, location),
          controllerAs: "vm",
          replace: true,
          size: "sm",
          backdrop: backdrop,
          template: TPL.modals.changePassword
        });
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/modals/changePassword.ts
 **/